const processApi = process.env.REACT_APP_API_URL || 'https://localhost:7187';

export const API_BASE_URL = processApi.trim();
